import { render } from "./milestone-plan-state.vue?vue&type=template&id=0506b4e8&scoped=true&ts=true"
import script from "./milestone-plan-state.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-state.vue?vue&type=script&lang=ts"

import "./milestone-plan-state.vue?vue&type=style&index=0&id=0506b4e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0506b4e8"]])

export default __exports__